// Comprehensive chemical database for auto-fill
// Each entry contains all data needed to populate the SDS row automatically

import { EXPANDED_CHEMICALS, CHEMICAL_CATEGORIES } from './chemicalDatabaseExpanded';

export { CHEMICAL_CATEGORIES };

// Chemical container image library (auto-assigned by chemical type)
const IMG = {
  white_jerrycan:
    'https://images.unsplash.com/photo-1663177207329-15541ee7951d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxjaGVtaWNhbCUyMGplcnJ5Y2FufGVufDB8fHx8MTc4MTYzNzAxN3ww&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop',
  blue_jerrycan:
    'https://images.unsplash.com/photo-1662022613044-fb06b3cd9a31?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxjaGVtaWNhbCUyMGplcnJ5Y2FufGVufDB8fHx8MTc4MTYzNzAxN3ww&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop',
  dark_container:
    'https://images.unsplash.com/photo-1771161582700-332a898b4419?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwZHJ1bXxlbnwwfHx8fDE3ODE2MzcwMTd8MA&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop',
  yellow_drum:
    'https://images.unsplash.com/photo-1579710144004-a44405d9e106?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHwxfHxjaGVtaWNhbCUyMGRydW18ZW58MHx8fHllbGxvd3wxNzgxNjM3MDI0fDA&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop',
  ibc_tank:
    'https://images.unsplash.com/photo-1633129167930-2019e0ba8257?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHw0fHxJQkMlMjB0YW5rfGVufDB8fHx8MTc4MTYzNzAzNnww&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop',
  red_fuel:
    'https://images.unsplash.com/photo-1729614355406-6dd60eaa2a64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxjaGVtaWNhbCUyMGplcnJ5Y2FufGVufDB8fHx8MTc4MTYzNzAxN3ww&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop',
  hazard_bottle:
    'https://images.unsplash.com/photo-1584028377143-21f876eb9c1e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxoYXphcmQlMjBib3R0bGV8ZW58MHx8fHwxNzgxNjM3MDMxfDA&ixlib=rb-4.1.0&q=85&w=200&h=200&fit=crop',
};

export const CHEMICAL_IMAGES = IMG;

export const CHEMICAL_DATABASE = [
  // === Water Treatment Chemicals (Hydrex series) ===
  {
    name: 'Hydrex 1320',
    aliases: ['hydrex1320', 'hydrex 1320'],
    chemicalName: 'مادة معالجة مياه',
    unNumber: 'غير مصنف',
    ghsClassification: 'غير مصنف كخطر',
    ghsSymbols: [],
    usage: 'مادة مانعة للتكلس والترسبات في أنظمة المياه',
    image: IMG.white_jerrycan,
    nfpa: { health: 1, fire: 0, reactivity: 0, special: '-' },
    risk: { probability: 'منخفضة', severity: 'بسيطة', level: 'منخفض', class: 'منخفض' },
  },
  {
    name: 'Hydrex 2331',
    aliases: ['hydrex2331', 'hydrex 2331'],
    chemicalName: 'مادة معالجة مياه',
    unNumber: 'UN 1760',
    ghsClassification: 'سائل آكل (Corrosive)',
    ghsSymbols: ['corrosive'],
    usage: 'معالجة أنظمة المياه الصناعية',
    image: IMG.blue_jerrycan,
    nfpa: { health: 2, fire: 0, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'متوسطة', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'Hydrex 7321',
    aliases: ['hydrex7321', 'hydrex 7321'],
    chemicalName: 'مادة معالجة مياه',
    unNumber: 'UN 3265',
    ghsClassification: 'سائل آكل (Corrosive)',
    ghsSymbols: ['corrosive'],
    usage: 'معالجة المياه الصناعية',
    image: IMG.blue_jerrycan,
    nfpa: { health: 3, fire: 0, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },

  {
    name: 'Hydrex 2510',
    aliases: ['hydrex2510', 'hydrex 2510'],
    chemicalName: 'مادة معالجة مياه',
    unNumber: 'UN 1760',
    ghsClassification: 'سائل آكل (Corrosive)',
    ghsSymbols: ['corrosive'],
    usage: 'مادة مانعة للتآكل في أنظمة المياه الصناعية',
    image: IMG.blue_jerrycan,
    nfpa: { health: 2, fire: 0, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'متوسطة', level: 'متوسط', class: 'متوسطة' },
  },
  {
    name: 'Hydrex 2520',
    aliases: ['hydrex2520', 'hydrex 2520'],
    chemicalName: 'مادة معالجة مياه',
    unNumber: 'UN 1760',
    ghsClassification: 'سائل آكل (Corrosive)',
    ghsSymbols: ['corrosive'],
    usage: 'معالجة وتثبيط التآكل في أنظمة التبريد',
    image: IMG.blue_jerrycan,
    nfpa: { health: 2, fire: 0, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'متوسطة', level: 'متوسط', class: 'متوسطة' },
  },
  {
    name: 'Hydrex 4101',
    aliases: ['hydrex4101', 'hydrex 4101'],
    chemicalName: 'مبيد حيوي (Biocide)',
    unNumber: 'UN 3082',
    ghsClassification: 'مادة سامة وضارة بالبيئة',
    ghsSymbols: ['toxic', 'environment'],
    usage: 'مبيد حيوي لمنع نمو البكتيريا في أنظمة المياه',
    image: IMG.ibc_tank,
    nfpa: { health: 2, fire: 0, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'متوسطة', level: 'متوسط', class: 'متوسطة' },
  },
  {
    name: 'Hydrex 6010',
    aliases: ['hydrex6010', 'hydrex 6010'],
    chemicalName: 'مادة معالجة مياه',
    unNumber: 'غير مصنف',
    ghsClassification: 'غير مصنف كخطر',
    ghsSymbols: [],
    usage: 'مادة معالجة لأنظمة المياه المغلقة',
    image: IMG.white_jerrycan,
    nfpa: { health: 1, fire: 0, reactivity: 0, special: '-' },
    risk: { probability: 'منخفضة', severity: 'بسيطة', level: 'منخفض', class: 'منخفض' },
  },
  {
    name: 'Hydrex 8200',
    aliases: ['hydrex8200', 'hydrex 8200'],
    chemicalName: 'مادة معالجة مياه',
    unNumber: 'UN 3265',
    ghsClassification: 'سائل آكل (Corrosive)',
    ghsSymbols: ['corrosive'],
    usage: 'معالجة الغلايات وأنظمة المياه عالية الضغط',
    image: IMG.blue_jerrycan,
    nfpa: { health: 3, fire: 0, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },

  // === Common Industrial Chemicals ===
  {
    name: 'هيبوكلوريت الصوديوم 12-16%',
    aliases: ['sodium hypochlorite', 'هيبوكلوريت الصوديوم', 'كلور سائل', 'naclo'],
    chemicalName: 'Sodium Hypochlorite',
    unNumber: 'UN 1791',
    ghsClassification: 'مادة آكالة ومؤكسدة',
    ghsSymbols: ['corrosive', 'oxidizer'],
    usage: 'تعقيم وتطهير المياه',
    image: IMG.dark_container,
    nfpa: { health: 3, fire: 0, reactivity: 1, special: '-' },
    risk: { probability: 'متوسطة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'حمض الكبريتيك',
    aliases: ['sulfuric acid', 'h2so4', 'حمض كبريتيك', 'حامض الكبريتيك'],
    chemicalName: 'Sulfuric Acid',
    unNumber: 'UN 1830',
    ghsClassification: 'مادة آكالة شديدة',
    ghsSymbols: ['corrosive'],
    usage: 'استخدامات صناعية ومعالجة المياه',
    image: IMG.yellow_drum,
    nfpa: { health: 3, fire: 0, reactivity: 2, special: 'W' },
    risk: { probability: 'مرتفعة', severity: 'كبيرة جداً', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'حمض الهيدروكلوريك',
    aliases: ['hydrochloric acid', 'hcl', 'حمض هيدروكلوريك', 'حمض الكلور'],
    chemicalName: 'Hydrochloric Acid',
    unNumber: 'UN 1789',
    ghsClassification: 'مادة آكالة',
    ghsSymbols: ['corrosive'],
    usage: 'تنظيف صناعي ومعالجة المعادن',
    image: IMG.yellow_drum,
    nfpa: { health: 3, fire: 0, reactivity: 1, special: '-' },
    risk: { probability: 'متوسطة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'هيدروكسيد الصوديوم (الصودا الكاوية)',
    aliases: ['sodium hydroxide', 'naoh', 'caustic soda', 'صودا كاوية', 'هيدروكسيد الصوديوم'],
    chemicalName: 'Sodium Hydroxide',
    unNumber: 'UN 1823',
    ghsClassification: 'مادة آكالة',
    ghsSymbols: ['corrosive'],
    usage: 'معالجة المياه وصناعة المنظفات',
    image: IMG.blue_jerrycan,
    nfpa: { health: 3, fire: 0, reactivity: 1, special: '-' },
    risk: { probability: 'متوسطة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'بيروكسيد الهيدروجين',
    aliases: ['hydrogen peroxide', 'h2o2', 'بيروكسيد هيدروجين', 'ماء أكسجين'],
    chemicalName: 'Hydrogen Peroxide',
    unNumber: 'UN 2014',
    ghsClassification: 'مادة مؤكسدة وآكالة',
    ghsSymbols: ['corrosive', 'oxidizer'],
    usage: 'تعقيم وتبييض ومعالجة المياه',
    image: IMG.ibc_tank,
    nfpa: { health: 2, fire: 0, reactivity: 3, special: 'OX' },
    risk: { probability: 'متوسطة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'الأمونيا',
    aliases: ['ammonia', 'nh3', 'أمونيا', 'نشادر'],
    chemicalName: 'Ammonia',
    unNumber: 'UN 1005',
    ghsClassification: 'غاز سام وقابل للاشتعال',
    ghsSymbols: ['corrosive', 'flammable', 'toxic'],
    usage: 'تبريد صناعي وصناعة الأسمدة',
    image: IMG.ibc_tank,
    nfpa: { health: 3, fire: 1, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'الميثانول',
    aliases: ['methanol', 'methyl alcohol', 'ميثانول', 'كحول ميثيلي', 'ch3oh'],
    chemicalName: 'Methanol',
    unNumber: 'UN 1230',
    ghsClassification: 'سائل قابل للاشتعال وسام',
    ghsSymbols: ['flammable', 'toxic', 'health-hazard'],
    usage: 'مذيب ووقود صناعي',
    image: IMG.hazard_bottle,
    nfpa: { health: 1, fire: 3, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'الأسيتون',
    aliases: ['acetone', 'أسيتون'],
    chemicalName: 'Acetone',
    unNumber: 'UN 1090',
    ghsClassification: 'سائل قابل للاشتعال',
    ghsSymbols: ['flammable'],
    usage: 'مذيب صناعي',
    image: IMG.hazard_bottle,
    nfpa: { health: 1, fire: 3, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'متوسطة', level: 'متوسط', class: 'متوسطة' },
  },
  {
    name: 'الديزل',
    aliases: ['diesel', 'gas oil', 'ديزل', 'سولار'],
    chemicalName: 'Diesel Fuel',
    unNumber: 'UN 1202',
    ghsClassification: 'سائل قابل للاشتعال',
    ghsSymbols: ['flammable', 'health-hazard'],
    usage: 'وقود للمحركات والمولدات',
    image: IMG.red_fuel,
    nfpa: { health: 0, fire: 2, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'متوسطة', level: 'متوسط', class: 'متوسطة' },
  },
  {
    name: 'البنزين (الجازولين)',
    aliases: ['gasoline', 'petrol', 'بنزين', 'جازولين', 'بترول'],
    chemicalName: 'Gasoline',
    unNumber: 'UN 1203',
    ghsClassification: 'سائل قابل للاشتعال بشدة',
    ghsSymbols: ['flammable', 'health-hazard', 'environment'],
    usage: 'وقود للمركبات',
    image: IMG.red_fuel,
    nfpa: { health: 1, fire: 3, reactivity: 0, special: '-' },
    risk: { probability: 'مرتفعة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'الكيروسين',
    aliases: ['kerosene', 'jet fuel', 'كيروسين', 'وقود طائرات'],
    chemicalName: 'Kerosene',
    unNumber: 'UN 1223',
    ghsClassification: 'سائل قابل للاشتعال',
    ghsSymbols: ['flammable', 'health-hazard'],
    usage: 'وقود للتدفئة والإضاءة',
    image: IMG.red_fuel,
    nfpa: { health: 1, fire: 2, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'متوسطة', level: 'متوسط', class: 'متوسطة' },
  },
  {
    name: 'الكلور',
    aliases: ['chlorine', 'cl2', 'كلور', 'غاز الكلور'],
    chemicalName: 'Chlorine',
    unNumber: 'UN 1017',
    ghsClassification: 'غاز سام ومؤكسد',
    ghsSymbols: ['oxidizer', 'toxic', 'environment'],
    usage: 'تعقيم المياه وصناعة المواد الكيميائية',
    image: IMG.ibc_tank,
    nfpa: { health: 4, fire: 0, reactivity: 0, special: 'OX' },
    risk: { probability: 'متوسطة', severity: 'كبيرة جداً', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'هيبوكلوريت الكالسيوم',
    aliases: ['calcium hypochlorite', 'هيبوكلوريت الكالسيوم', 'كلور صلب'],
    chemicalName: 'Calcium Hypochlorite',
    unNumber: 'UN 2880',
    ghsClassification: 'مادة مؤكسدة آكالة',
    ghsSymbols: ['oxidizer', 'corrosive'],
    usage: 'تعقيم المياه وحمامات السباحة',
    image: IMG.ibc_tank,
    nfpa: { health: 3, fire: 0, reactivity: 1, special: 'OX' },
    risk: { probability: 'متوسطة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'الإيثانول',
    aliases: ['ethanol', 'ethyl alcohol', 'إيثانول', 'كحول إيثيلي'],
    chemicalName: 'Ethanol',
    unNumber: 'UN 1170',
    ghsClassification: 'سائل قابل للاشتعال',
    ghsSymbols: ['flammable'],
    usage: 'مذيب وتعقيم',
    image: IMG.hazard_bottle,
    nfpa: { health: 2, fire: 3, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'متوسطة', level: 'متوسط', class: 'متوسطة' },
  },
  {
    name: 'حمض النيتريك',
    aliases: ['nitric acid', 'hno3', 'حمض نيتريك', 'حامض النيتريك'],
    chemicalName: 'Nitric Acid',
    unNumber: 'UN 2031',
    ghsClassification: 'مادة آكالة ومؤكسدة',
    ghsSymbols: ['corrosive', 'oxidizer'],
    usage: 'صناعة الأسمدة والمتفجرات',
    image: IMG.yellow_drum,
    nfpa: { health: 4, fire: 0, reactivity: 0, special: 'OX' },
    risk: { probability: 'متوسطة', severity: 'كبيرة جداً', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'البروبان',
    aliases: ['propane', 'lpg', 'بروبان', 'غاز مسال'],
    chemicalName: 'Propane',
    unNumber: 'UN 1978',
    ghsClassification: 'غاز قابل للاشتعال بشدة',
    ghsSymbols: ['flammable'],
    usage: 'وقود للتدفئة والطبخ',
    image: IMG.red_fuel,
    nfpa: { health: 1, fire: 4, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'كبيرة', level: 'مرتفع', class: 'مرتفعة' },
  },
  {
    name: 'التولوين',
    aliases: ['toluene', 'تولوين', 'تولوول'],
    chemicalName: 'Toluene',
    unNumber: 'UN 1294',
    ghsClassification: 'سائل قابل للاشتعال وسام',
    ghsSymbols: ['flammable', 'health-hazard'],
    usage: 'مذيب صناعي للدهانات',
    image: IMG.hazard_bottle,
    nfpa: { health: 2, fire: 3, reactivity: 0, special: '-' },
    risk: { probability: 'متوسطة', severity: 'متوسطة', level: 'متوسط', class: 'متوسطة' },
  },
  // === Expanded categories (Esters, Aldehydes, Ketones, Alcohols, Aromatics, ...) ===
  ...EXPANDED_CHEMICALS,
];

// Search function: find chemical by name (fuzzy match)
export function findChemical(query) {
  if (!query) return null;
  const q = query.trim().toLowerCase();

  // Exact match first
  let found = CHEMICAL_DATABASE.find((c) => c.name.toLowerCase() === q);
  if (found) return found;

  // Alias match
  found = CHEMICAL_DATABASE.find((c) =>
    c.aliases.some((a) => a.toLowerCase() === q)
  );
  if (found) return found;

  // Partial match (starts with)
  found = CHEMICAL_DATABASE.find(
    (c) =>
      c.name.toLowerCase().startsWith(q) ||
      c.aliases.some((a) => a.toLowerCase().startsWith(q))
  );
  if (found) return found;

  // Contains match
  found = CHEMICAL_DATABASE.find(
    (c) =>
      c.name.toLowerCase().includes(q) ||
      c.chemicalName.toLowerCase().includes(q) ||
      c.aliases.some((a) => a.toLowerCase().includes(q))
  );
  return found;
}

// Search returning multiple matches for dropdown suggestions
// Searches by: name, chemical name, aliases, UN number, CAS number (partial OK),
// usage text, and chemical family keywords (ester/aldehyde/ketone/...).
const FAMILY_KEYWORDS = {
  ester: ['ester','esters','استرات','إسترات','استرات'],
  aldehyde: ['aldehyde','aldehydes','ألدهيد','الدهيد','الألدهيدات'],
  ketone: ['ketone','ketones','كيتون','الكيتونات'],
  alcohol: ['alcohol','alcohols','كحول','الكحولات'],
  aromatic: ['aromatic','aromatics','عطري','عطرية'],
  ether: ['ether','ethers','إيثر','الإيثرات'],
  amine: ['amine','amines','أمين','أمينات'],
  halogen: ['halogen','halogenated','مهلجن','مهلجنة'],
  acid: ['acid','acids','حمض','أحماض'],
  base: ['base','bases','قاعدة','هيدروكسيد'],
  oxidizer: ['oxidizer','oxidizers','مؤكسد','مؤكسدة'],
  gas: ['gas','gases','غاز','غازات'],
  flammable: ['flammable','قابل للاشتعال','اشتعال'],
};

function _matchesFamily(c, q) {
  const blob = `${c.name} ${c.chemicalName} ${c.usage} ${(c.aliases || []).join(' ')} ${(c.ghsSymbols || []).join(' ')} ${c.ghsClassification || ''}`.toLowerCase();
  for (const [key, terms] of Object.entries(FAMILY_KEYWORDS)) {
    if (terms.some((t) => q.includes(t.toLowerCase()))) {
      if (blob.includes(key)) return true;
      // Specific family checks via known english words in chemicalName
      if (key === 'ester' && /(\bacetate\b|\bbutyrate\b|\bformate\b|\bacrylate\b|\bmethacrylate\b)/.test(blob)) return true;
      if (key === 'aldehyde' && /(aldehyde|formaldehyde|acrolein|furfural)/.test(blob)) return true;
      if (key === 'ketone' && /(ketone|acetone|MEK|MIBK|MPK|acetophenone)/i.test(c.chemicalName + ' ' + (c.aliases||[]).join(' '))) return true;
      if (key === 'alcohol' && /(ol\b|alcohol|glycol|glycerin|ethanol|methanol|butanol|propanol)/.test(blob)) return true;
    }
  }
  return false;
}

export function searchChemicals(query, limit = 8) {
  if (!query || !query.trim()) return CHEMICAL_DATABASE.slice(0, limit);
  const q = query.trim().toLowerCase();
  const qDigits = q.replace(/[^0-9]/g, '');

  return CHEMICAL_DATABASE.filter((c) => {
    if (c.name.toLowerCase().includes(q)) return true;
    if ((c.chemicalName || '').toLowerCase().includes(q)) return true;
    if ((c.aliases || []).some((a) => a.toLowerCase().includes(q))) return true;
    if ((c.usage || '').toLowerCase().includes(q)) return true;
    // UN/CAS digits
    const unDigits = String(c.unNumber || '').replace(/[^0-9]/g, '');
    if (qDigits && qDigits.length >= 3 && unDigits && unDigits.includes(qDigits)) return true;
    const casDigits = String(c.casNumber || c.cas || '').replace(/[^0-9]/g, '');
    if (qDigits && qDigits.length >= 4 && casDigits && casDigits.includes(qDigits)) return true;
    if ((c.unNumber || '').toLowerCase().includes(q)) return true;
    // Family search (Esters, Aldehydes, Ketones, ...)
    if (_matchesFamily(c, q)) return true;
    return false;
  }).slice(0, limit);
}

// Smart match: case-insensitive, ignores extra spaces.
// Matches by name, alias, OR UN number.
// Returns the chemical object if a confident match exists, null otherwise.
export function smartMatchChemical(name) {
  if (!name) return null;
  const norm = (s) => String(s).trim().toLowerCase().replace(/\s+/g, ' ');
  const target = norm(name);

  // 1. Exact name match (case-insensitive)
  let found = CHEMICAL_DATABASE.find((c) => norm(c.name) === target);
  if (found) return found;

  // 2. Exact alias match
  found = CHEMICAL_DATABASE.find((c) => c.aliases.some((a) => norm(a) === target));
  if (found) return found;

  // 3. UN number match (e.g., "UN 1760", "1760", "un1760")
  const targetDigits = target.replace(/[^0-9]/g, '');
  if (targetDigits && targetDigits.length >= 4) {
    found = CHEMICAL_DATABASE.find((c) => {
      const unDigits = String(c.unNumber).replace(/[^0-9]/g, '');
      return unDigits === targetDigits;
    });
    if (found) return found;
  }

  // 4. Strip spaces and compare (e.g., "hydrex2510" ≈ "hydrex 2510")
  const noSpace = (s) => norm(s).replace(/\s+/g, '');
  found = CHEMICAL_DATABASE.find(
    (c) =>
      noSpace(c.name) === noSpace(name) ||
      c.aliases.some((a) => noSpace(a) === noSpace(name))
  );
  if (found) return found;

  return null;
}

// Apply chemical template to a row, preserving the user's typed name (in case of casing changes)
export function applyTemplateToChemical(chem, template) {
  return {
    ...chem,
    chemicalName: template.chemicalName,
    unNumber: template.unNumber,
    ghsClassification: template.ghsClassification,
    ghsSymbols: [...template.ghsSymbols],
    usage: template.usage,
    image: template.image,
    nfpa: { ...template.nfpa },
    risk: { ...template.risk, material: chem.name },
  };
}
